import { render } from "./ResponseCode.vue?vue&type=template&id=07f32a82"
import script from "./ResponseCode.vue?vue&type=script&lang=js"
export * from "./ResponseCode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__